import { render, staticRenderFns } from "./PreCommunication.vue?vue&type=template&id=eb18d9e4&scoped=true"
import script from "./PreCommunication.vue?vue&type=script&lang=js"
export * from "./PreCommunication.vue?vue&type=script&lang=js"
import style0 from "./PreCommunication.vue?vue&type=style&index=0&id=eb18d9e4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb18d9e4",
  null
  
)

export default component.exports